import { Helmet } from 'react-helmet'
import { OrderLogTable, OrdersLogExportButton } from 'components/logsOrders'

const OrdersLog = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Orders Logs </title>
      </Helmet>
      <OrdersLogExportButton />
      <OrderLogTable />
    </>
  )
}

export default OrdersLog
